export default "__VITE_ASSET__edd478f1__"